<template>
 <div class="ParticipationHader">
     <div class="ParticipationHader_top">
         <div class="txt_p">
              <div class="ParticipationHader_txt">
                我们珍惜每一次合作的可能,非常期待您的留言
              </div>
              <div class="ParticipationHader_p">
                    再小的个体 也有自己的VR展示平台
               </div>
         </div>
     </div>
 </div>
</template>
<script>

export default {
   name:"ParticipationHader"
}
</script>
<style scoped>
@media screen and (min-width: 1921px) {
  .ParticipationHader_top{
    height: 780px!important;
  }
}
.ParticipationHader_top{
    width: 100%;
    height: 640px;
    background: url("https://oss.3dyunchuang.com/home_pic/banner/Particpation_top.jpg") 100% 100%;
    position: relative;
}
.txt_p{
    width: 590px;
    height: 184px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-top: 54px;
    transform: translate(-50%,-50%);
}
.ParticipationHader_txt{
    font-size: 24px;
    color: #fff;
    text-align: center;
    font-weight: bold;
    margin-bottom: 104px;
    letter-spacing:2px
}
.ParticipationHader_p{
    width: 423px;
    height: 51px;
    border: 1px solid #fff;
    text-align: center;
    line-height: 52px;
    font-size: 18px;
    font-weight: bold;
    color: #fff;
    margin: 0px auto;
    letter-spacing:2px
}
</style>


// WEBPACK FOOTER //
// src/common/Participation/Participation-hader.vue